import * as React from "react";

function SvgIcFacebook(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.189 7.77468C14.815 7.69988 14.3099 7.644 13.9922 7.644C13.132 7.644 13.0761 8.018 13.0761 8.6164V9.68164H15.2264L15.039 11.8882H13.0761V18.6H10.3838V11.8882H9V9.68164H10.3838V8.31676C10.3838 6.4472 11.2625 5.4 13.4686 5.4C14.2351 5.4 14.7961 5.5122 15.5252 5.6618L15.189 7.77468Z" fill="currentColor"/>
    </svg>
  );
}

export default SvgIcFacebook;
